// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/game/commands/*.ts
import * as m0 from './commands/chat';
import * as m1 from './commands/core';
import * as m2 from './commands/items';
import * as m3 from './commands/tutorial';
export const commandModules = [m0, m1, m2, m3] as const;
